import React, { useContext, useState } from "react";
import Footer from "./Footer";
import config from "../config/index.json";
import { useNavigate } from "react-router-dom";

import { getDatabase, ref, set } from "firebase/database";

import { AuthContext } from "../context/UserContext";
import SimpleHeader from "./SimpleHeader";

interface UserField {
  name: string;
  surname: string;
  email: string;
  password: string;
  cpassword: string;
  telephone: string;
  address: string;
  cap: string;
  city: string;
  province: string;
  nation: string;
  tax_id: string;
  gender: string;
  city_of_birth: string;
  date_of_birth: string;
  agency: string;
  role: string;
  company_postcode: string;
  company_province: string;
  company_nation: string;
}

function Register() {
  const { createUser, signIn } = useContext(AuthContext);
  const { images } = config;
  const { logo } = images;
  const [policyMessage, setPolicyMesage] = useState(false);
  const [errMessage, setErrMessage] = useState(false);
  const [genderMessage, setGenderMessage] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const form = e.target;
    console.log(form["policy_agree"].checked);
    if (!form["policy_agree"].checked) {
      setPolicyMesage(true);
      console.log("haha");
      return;
    }

    if (form["policy_agree"]) {
    }

    createUser(form["email"].value, form["password"].value)
      .then((result: any) => {
        const user = result.user;
        console.log("registered user", user);
        const db = getDatabase();
        if (form["gender"].value == "Sesso") {
          setGenderMessage(true);
          document.getElementById("gender")?.click();
        }
        set(ref(db, "users/" + user.uid), {
          name: form["name"].value,
          surname: form["surname"].value,
          email: form["email"].value,
          telephone: form["telephone"].value,
          linkedin: form["linkedin"].value,
          address: form["address"].value,
          cap: form["cap"].value,
          city: form["city"].value,
          province: form["province"].value,
          nation: form["nation"].value,
          tax_id: form["tax_id"].value,
          gender: form["gender"].value,
          city_of_birth: form["city_of_birth"].value,
          date_of_birth: form["date_of_birth"].value,
          agency: form["agency"].value,
          role: form["role"].value,
          company_postcode: form["company_postcode"].value,
          company_address: form["company_address"].value,
          company_city: form["company_city"].value,
          company_province: form["company_province"].value,
          company_nation: form["company_nation"].value,
        })
          .then(() => {
            signIn(form["email"].value, form["password"].value)
              .then((result: any) => {
                const user = result.user;
                console.log(user);
                form.reset();
                navigate("/");
              })
              .catch((error: any) => {
                console.error("signin", error);
              });
          })
          .catch((error) => {
            console.log("setdata", error);
          });
      })
      .catch((error: any) => {
        setErrMessage(true);
        document.getElementById("GoToForm")?.click();
      });
  };
  return (
    <>
      <section
        id="hero"
        className="bg-hero brightness-100 bg-no-repeat w-full bg-center bg-cover pt-80 pb-6 h-[40vh]"
      >
      </section>
      <SimpleHeader/>
      <section>
        <div className="pb-[200px]">
          <div className="grid grid-cols-1 md:grid-cols-5">
            <div className="col-span-2 pt-[100px] pl-[60px] md:pr-[20px] lg:pr-[60px]">
              <hr className="color-[#00a695] border border-[#00a695] w-4/5" />
              <div className="mt-[20px]">
                <strong>Hai bisogno di aiuto?</strong>
              </div>
              <a className="text-[#00a695]" href="">
                info@italyhlg.it
              </a>
              <p className="mt-[40px]">
                L 'iscrizione a Italy HLG permette di usufruire di:
              </p>
              <ul className="mt-[20px] pl-[40px] list-disc gap-[10px]">
                <li>
                  Ampie possibilità di Network con altri professionisti del
                  licensing e del business development di aziende e
                  organizzazioni nel settore Healthcare.
                  <strong>
                    altri professionisti del licensing e del business
                    development
                  </strong>
                  di aziende e organizzazioni nel settore Healthcare.
                </li>
                <li>
                  <strong>Accesso alla sezione riservata</strong>del sito.
                </li>
                <li>
                  Offre{" "}
                  <strong>partecipazione ad eventi di alta formazione</strong>
                  (BD Academy), godendo di condizioni economiche di favore
                  riservate agli associati.
                </li>
                <li>
                  Partecipazione ad altre
                  <strong>iniziative culturali e ricreative</strong>organizzate
                  dall'associazione con la finalità di
                  <strong>sviluppare il network.</strong>
                </li>
                <li>
                  Partecipazione ad{" "}
                  <strong>
                    eventi organizzati da IPLS International Partnering in
                    Lifescience Society e dalle altre associate EU.
                  </strong>
                </li>
                <li>
                  <strong>
                    Abbonamento al Business Development & Licensing Journal.
                  </strong>
                </li>
              </ul>
              <div className="mt-8">
                <a
                  className="text-[#125190] text-lg font-[700] underline"
                  href=""
                >
                  Per i nuovi iscritti
                </a>
              </div>
              <ul className="mt-[20px] pl-[40px] list-disc gap-[10px]">
                <li>
                  <strong>è necessario completare il form</strong>nei suoi campi
                  obbligatori, ed una volta confermata via mail la richiesta,
                  procedere al versamento della
                  <strong>quota associativa di300 Euro</strong> tramite bonifico
                  bancario o assegno non trasferibile alle seguenti coordinate:
                </li>
                <li>Italy HLG - Healthcare Licensing Group</li>
                <li>UniCredit Banca - Agenzia Milano Buonarroti</li>
                <li>Via Michelangelo Buonarroti 19 - 20149 Milano</li>
                <li>Codice IBAN IT 47 N 02008 01767 000100480153</li>
                <li>
                  Causale: Quota associativa 2023 + Nome Associato + Nome
                  Azienda
                </li>
              </ul>
              <h1 className="text-[17px] font-bold mt-6">
                L'iscrizione del nuovo associato diventa effettiva dopo
                l'approvazione da parte del consiglio direttivo.
              </h1>
            </div>

            <div id="" className="col-span-3 z-10 mt-[-120px]">
              <div id="form" className="z-50 bg-white p-24">
                <div className="text-5xl text-[#0c2957] font-[700]">
                  <h1 className="mb-6">Iscrizione e</h1>
                  <h1>registrazione</h1>
                </div>
                <p className="mt-6 font=[600]">
                  Una bella introduzione qui ipsum dolor sit amet, consectetur
                  adipiscing elit. Duis euismod euismod sem, posuere tincidunt
                  sapien maximus sed. Duis erat risus, lacinia a neque a,,,
                </p>
                <a id="GoToForm" href="#form"></a>
                <a id="GoToGender" href="#gender"></a>
                <form className="mt-6 w-[80%]" onSubmit={handleSubmit}>
                  {errMessage && (
                    <h1 className="text-red-600 font-bold">
                      Registrazione non riuscita. Controlla che l'e-mail sia già
                      presente registrato o i dati non sono nuovamente corretti.
                    </h1>
                  )}
                  <input
                    id="name"
                    name="name"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    defaultValue=""
                    placeholder="Name"
                  />
                  <input
                    id="surname"
                    name="surname"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Cognome"
                  />
                  <input
                    id="email"
                    name="email"
                    className="block w-full p-5 my-4 border border-1"
                    type="email"
                    placeholder="E-mail"
                  />
                  <input
                    name="password"
                    id="password"
                    className="block w-full p-5 my-4 border border-1"
                    type="password"
                    placeholder="Password"
                  />
                  <input
                    id="cpassword"
                    name="cpassword"
                    className="block w-full p-5 my-4 border border-1"
                    type="password"
                    placeholder="Ripeti password"
                  />

                  <input
                    id="linkedin"
                    name="linkedin"
                    className="block w-full p-5 mb-4 mt-20 border border-1"
                    type="text"
                    placeholder="Profilo Linkedin"
                  />

                  <input
                    id="telephone"
                    name="telephone"
                    className="block w-full p-5 mb-4 mt-20 border border-1"
                    type="phone"
                    placeholder="Telefono"
                  />
                  <input
                    id="address"
                    name="address"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Indirizzo"
                  />
                  <input
                    id="cap"
                    name="cap"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="CAP"
                  />
                  <input
                    id="city"
                    name="city"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Città

                    "
                  />
                  <input
                    id="province"
                    name="province"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Provincia"
                  />
                  <input
                    id="nation"
                    name="nation"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Nazione"
                  />

                  <input
                    id="tax_id"
                    name="tax_id"
                    className="block w-full p-5 my-4 mt-20 border border-1"
                    type="text"
                    placeholder="Codice Fiscale"
                  />
                  <select
                    id="gender"
                    name="gender"
                    className="block w-full p-5 my-4 border border-1"
                  >
                    <option value="sesso">Sesso</option>
                    <option value="man">Maschio</option>
                    <option value="woman">Femmina</option>
                    <option value="woman">Preferisco non dire</option>
                  </select>
                  {genderMessage && (
                    <h1 className="text-red-600">
                      Per favore seleziona il tuo genere
                    </h1>
                  )}
                  <input
                    id="city_of_birth"
                    name="city_of_birth"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Città di nascita"
                  />
                  <input
                    id="date_of_birth"
                    name="date_of_birth"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Data di nascita"
                  />

                  <input
                    id="agengy"
                    name="agency"
                    type="text"
                    className="block w-full p-5 my-4 mt-20 border border-1"
                    placeholder="Azienda"
                  />
                  <input
                    id="role"
                    name="role"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Ruolo"
                  />
                  <input
                    id="company_address"
                    name="company_address"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Indirizzo Azienda"
                  />
                  <input
                    id="company_postcode"
                    name="company_postcode"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="CAP Azienda"
                  />
                  <input
                    id="company_city"
                    name="company_city"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Città Azienda"
                  />
                  <input
                    id="company_province"
                    name="company_province"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Provincia Azienda"
                  />
                  <input
                    id="company_nation"
                    name="company_nation"
                    className="block w-full p-5 my-4 border border-1"
                    type="text"
                    placeholder="Nazione Azienda"
                  />
                  <div className="mt-8 flex gap-2">
                    <input
                      id="policy_agree"
                      name="policy_agree"
                      type="checkbox"
                      className="border-4 shadow border-gray-400 text-[24px] w-[20px] h-[20px]"
                    />
                    <div>
                      {"   "}Accetto{" "}
                      <a className="underline" href="">
                        termini e condizioni della privacy
                      </a>
                    </div>
                  </div>
                  {policyMessage && (
                    <div className="text-red-600 text-xs mt-2">
                      You should agree to the policy to register.
                    </div>
                  )}
                  <button
                    className="block w-full p-6 my-4 uppercase text-white text-xs bg-[#00a695]"
                    type="submit"
                  >
                    CONCLUDI LA REGISTRAZIONE
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
    </>
  );
}

export default Register;
